export default __webpack_public_path__ + "static/media/code-ic.c5b7afc1.svg";